/**
 * Foxit Storage Store
 */
 import { message } from 'antd';
import { observable, action, computed, } from 'mobx';
import { store } from 'Store/store.index';
import * as APP_CONSTANTS from 'Constants/app.constant';
import { 
    // USER_SIGN_IN_SUCCESS,
    USER_UPDATE_SUBSCRIPTION,
} from 'Store/constants';
import { storageAppApi } from "Api/index";
import intl from 'react-intl-universal';
import { bytesTobytes, isCanvas, queryVariable } from 'Utils/utils';
import { COLLABORATION_FILE_SIZE_LIMIT } from '@/limit.constant';
import { convertController } from '../components/viewer/Controllers/index';
import { CONVERT_TYPE } from "Api/index";

class StorageAppStore {
    @observable currentDocObject = null;
    @observable currentFolder = null;
    @observable autoSaveStatus = 'hide'; // 自动保存到Storage状态 loading success hide
    @observable usedSize = 0; // Storage已使用大小
    @observable rootFolder; // Storage 根路径文件夹对象
    @observable autoSaveOnDocModifiedSwitch = 'on'; // 文档修改后自动保存开关 on: 开启自动保存, off: 关闭自动保存
    @observable duplicateFileDialog = { // 显示Storage重名文档修改窗口
        visible: false,
        // doReplaceFill, // 执行替换操作
        // doRename, // 执行重名操作
        // folderId, // 父文件夹id
        // fileBuffer, // 需要上传的文件buffer
        // fileName,
        // existingFile, // 已存在的文件 
        // callback, // replace\rename成功后的回调方法 
    }; 
    @observable onCreateShareSuccess = null; // 创建为共享的文档成功回调函数
    @observable onCloseShareModal = null; // 关闭创建共享文档窗口回调函数
    @observable uploadFiles = []; // 正在上传中的文件名 {id,name,status:'error|uploading'}
    @observable isOnline = navigator.onLine; // 网络是否连接
    @observable password; // 文档密码
    @observable onAutoUploadFileSuccessOnOpenDoc = undefined; // 打开文档自动上传成功回调函数
    @observable autoSaveOnDocModifiedParams = undefined; // 文档修改后自动保存方法参数[isIncremental, isEnd]
    @observable storageDriveName = 'Storage';
    @observable showInsufficientFreeSpaceConfirmCount = 0;
    @observable showInsufficientFreeSpaceConfirmTimer;
    @observable curAutoSavedAt = ''; // 文档自动保存时间

    @action setCurAutoSavedAtTime = (timeStr) => {
        this.curAutoSavedAt = timeStr;
    }

    @action initialize() {
        // 是否已经开启过导航
        const hasNavigation = this.hasNavigation();
        const updateStorageSpaceSize = () => {
            return this.updateStorageSpaceSize().then(() => {
                if (this.usedSize >= this.maxSize) {
                    this.showInsufficientFreeSpaceConfirm();
                }
            });
        }
        if (!hasNavigation) {
            store.appStore.addAppEventListener(APP_CONSTANTS.NAVIGATION_OVER, () => {
                if (!store.appStore.isIncludeFoxitStorage || store.storageAppStore.isDisableStorage) return ;
                updateStorageSpaceSize();
            });
        } else {
            // store.appStore.addAppEventListener(USER_SIGN_IN_SUCCESS, () => {
            //     // 由于有些账号登录后是不需要去获取订阅信息，所以这边需要再获取大小
            //     if (!store.userStore.isEnterpriseUser) {
            //         updateStorageSpaceSize();
            //     }
            // });
            store.appStore.addAppEventListener(USER_UPDATE_SUBSCRIPTION, () => {
                if (!store.appStore.isIncludeFoxitStorage || store.storageAppStore.isDisableStorage) return ;
                updateStorageSpaceSize();
            });
            store.appStore.addAppEventListener(APP_CONSTANTS.SWITCH_CLOUD_ONLINE_STORAGE, () => {
                if (!store.appStore.isIncludeFoxitStorage || store.storageAppStore.isDisableStorage) return ;
                updateStorageSpaceSize();
            });
        }

        store.appStore.addAppEventListener(APP_CONSTANTS.SDK_OPEN_DOC_SUCCESS, () => {
            if(isCanvas()) return;
            if (queryVariable('origin') === 'chromeExtension') return ;
            // Auto save doc to cmis when open file success
            if (!store.appStore.isIncludeFoxitStorage || store.storageAppStore.isDisableStorage || 
                (store.docStore.docDriveName && store.docStore.docDriveName !== this.storageDriveName)) return ;
            this.setAutoSaveStatus(null);
            setTimeout(() => { // 防止isCollaborationMode拿不到
                const isCollaborationMode = store.appStore.isCollaborationMode();
                if (isCollaborationMode) {
                    const { cmisDocId, docName, docSize, reviewSessionID, cUserID } = store.collaborationStore.shareReviewData;
                    const isMe = store.userNewStore.userData.userId === cUserID;
                    return cmisDocId && storageAppApi.addRecent(cmisDocId, docName, isMe ? 1 : 0, docSize, reviewSessionID);
                }
                if (this.currentDocObject) return ; // currentDocObject 存在表示是从Storage table进入，不需要再上传           
                const autoUploadToFoxitStorage = this.isAutoSave();
                if (!autoUploadToFoxitStorage) return ;
                this.setAutoSaveStatus('loading');
                this.uploadCurrentDoc(this.currentFolder ? this.currentFolder.objectId : undefined, undefined, objectInfo => {
                    this.setCurrentDoc(objectInfo);
                    store.docStore.docInfo.fileName = objectInfo.docName;
                }).then(res => {
                    this.updateStorageSpaceSize();
                    this.setAutoSaveStatus('success');
                    this.setModified(false);
                    if (this.onAutoUploadFileSuccessOnOpenDoc) {
                        this.onAutoUploadFileSuccessOnOpenDoc();
                        this.onAutoUploadFileSuccessOnOpenDoc = undefined;
                    }
                    return res;
                }).finally(() => {
                    this.setAutoSaveStatus('hide');
                }).catch(() => {
                    this.autoSaveOnDocModifiedSwitch = 'off';
                });
            }, 1000);
        });
        store.appStore.addAppEventListener(APP_CONSTANTS.SDK_WILL_CLOSE_DOC, () => {
            if (!store.appStore.isIncludeFoxitStorage || store.storageAppStore.isDisableStorage) return ;
            this.setCurrentDoc(null);
            this.currentFolder = null;
            this.autoSaveOnDocModifiedSwitch = 'on';
            this.setAutoSaveStatus(null);
            this.setPassword(undefined);
        });
        // 文档更新操作后，5秒内无更新操作，则自动保存
        store.appStore.addAppEventListener(APP_CONSTANTS.SDK_RENDER_FIRST_PAGE, () => { // 第一次渲染页面
            if (!store.appStore.isIncludeFoxitStorage || store.storageAppStore.isDisableStorage) return ;
            const PDFUI = window.pdfui;
            const autoSaveOnDocModified = (isIncremental, isEnd) => {
                if (!this.currentDocObject) return ;
                if (store.docStore.docDriveName !== this.storageDriveName) return ;
                if (this.autoSaveOnDocModifiedSwitch === 'on') {
                    this.autoSaveOnDocModified(isIncremental, isEnd);
                }
            }
            document.addEventListener('keydown', () => {
                if (this.timer === undefined) return ;
                autoSaveOnDocModified();
            });
            PDFUI.addViewerEventListener(UIExtension.UIEvents.switchStateHandler, (stateHandler, oldStateHandler) => {
                const oldStateName = oldStateHandler.getStateName();
                if (['page-editor', 'touch-up-editor'].includes(oldStateName) && store.appStore.docModified) {
                    autoSaveOnDocModified(true, true);
                }
            });
            PDFUI.addViewerEventListener(UIExtension.UIEvents.docModified, () => {
                const isCollaborationMode = store.appStore.isCollaborationMode();
                const inTeamsApp = store.teamsAppStore.inTeamsApp;
                if (isCollaborationMode || inTeamsApp) return;
                autoSaveOnDocModified();
            });
            // 密码保护操作，需要晚于 docModified 事件，且需要全量更新
            PDFUI.addViewerEventListener(UIExtension.UIEvents.securityTypeChanged, () => {
                if (!this.currentDocObject) return ;
                setTimeout(() => {
                    autoSaveOnDocModified(false); 
                }, 500);
                // 修改提示框内容
                setTimeout(() => {
                    PDFUI.getRootComponent().then(root => {
                        const alertComponent = root.querySelector('template-container>@alert');
                        if (alertComponent && (alertComponent.alertId === 'set-password-permission-alert')) {
                            alertComponent.element.querySelector('.fv__ui-dialog-message>span').innerHTML = intl.get('FoxitStorage.PasswordProtect.ApplyToFoxitStorage');
                        }
                    });
                }, 0);
            });
            // Fill esgin 盖章操作不需要自动保存
            PDFUI.addViewerEventListener('add-onlineSign', () => {
                setTimeout(() => {
                    this.timer && clearTimeout(this.timer);
                    this.timer = undefined;
                }, 500);
            });
            // 自定义返回首页功能
            this.customSetOnShowToSaveBeforeOpen(store.appStore.onShowToSaveBeforeOpen);
        });
        window.addEventListener('online', () => {
            this.isOnline = true;
        });
        window.addEventListener('offline', () => {
            this.isOnline = false;
        });
    }
    // 设置文档密码
    @action setPassword (password) {
        this.password = password;
    }
    // 设置当前从CMIS打开的文档信息
    @action setCurrentDoc (object) {
        if (object) {
            store.docStore.setDocDriveName('Storage');
        }
        this.currentDocObject = object;
    }
    // 设置当前目录
    @action setCurrentFolder (object) {
        this.currentFolder = object;
    }
    // 更新storage空间大小
    @action updateStorageSpaceSize () {
        return storageAppApi.getUseSpace().then(res => {
            this.usedSize = res.docSizeCount;
        });
    }
    // 上传文档到指定目录
    @action upload (folderId, fileBuffer, fileName, fileType, successCallback, uploadListId) {
        const fileSize = fileBuffer.byteLength;
        const ret = this.checkUploadFileSize(fileSize);
        if (!ret) return Promise.reject();
        return this.queryFileInFolder(fileName, folderId).then(res => {
            if (res) {
                return new Promise((resolve, reject) => {
                    // 已存在相同文件名的文件
                    if (this.duplicateFileDialog.visible) {
                        return reject();
                    }
                    this.duplicateFileDialog = {
                        visible: true,
                        uploadListId, // 上传列表中的id
                        folderId, // 父文件夹id
                        fileBuffer, // 需要上传的文件buffer
                        fileName,
                        fileType,
                        existingFile: res, // 已存在的文件
                        callback: successCallback, 
                        onSuccess: res => {// replace\rename成功后的回调方法 
                            successCallback && successCallback(res);
                            resolve();
                        },
                        onFailed: () => {
                            reject();
                        },
                    }
                });
            } else {
                return storageAppApi.createDocument(folderId, fileBuffer, fileName, fileType).then(res => {
                    this.updateStorageSpaceSize();
                    return storageAppApi.addRecent(res.docId, res.docName, 1, res.docSize, res.reviewSessionID).then(() => {
                        successCallback && successCallback(res);
                        return res;
                    });
                });
            }
        });
    }
    // 上传当前文档到CMIS, 默认到根目录
    @action uploadCurrentDoc (folderId, fileName, onSuccess) {
        return Promise.reject();
        const PDFUI = window.pdfui;
        const PDFVIEWER = PDFUI.pdfViewer;
        const pdfDoc = PDFVIEWER.currentPDFDoc;
        if (!pdfDoc) return ;
        let originalBuffer;
        let buffers = [];
        if (fileName && this.regExpName(fileName)) return ;
        return pdfDoc.getOriginalStream().then(buffer => {
            originalBuffer = buffer;
            return pdfDoc.getStream(({ arrayBuffer }) => {
                buffers.push(arrayBuffer);
            }, 0x0001 | 0x0002, true);
        }).then(() => {
            // 计算大小
            let currentDocSize = originalBuffer.byteLength;
            buffers.forEach(buffer => {
                currentDocSize += buffer.byteLength;
            });
            const ret = this.checkUploadFileSize(currentDocSize);
            if (!ret) return Promise.reject();
            let promise = Promise.resolve({docId: folderId});
            if (folderId === undefined) {
                console.log("getRootFolder 1")
                promise = this.getRootFolder();
            }
            return promise.then(folder => {
                // 上传origin buffer
                return this.upload(folder.docId, originalBuffer, fileName || pdfDoc.getFileName(), 'application/pdf', objectInfo => {
                    // 增量更新
                    storageAppApi.appendContentStream(objectInfo.docId, buffers).then((data) => {
                        objectInfo.lastDocId = data.docId;
                        onSuccess && onSuccess(objectInfo);
                    });
                });
            });
        });
    }
    /**
     * 自动更新当前文档到CMIS
     * isIncremental: 是否增量方式
     */
    @action updateCurrentDocToCmis (isIncremental = true, isEnd = false) {
        const currentDocObject = this.currentDocObject;
        const PDFUI = window.pdfui;
        const PDFVIEWER = PDFUI.pdfViewer;
        const pdfDoc = PDFVIEWER.currentPDFDoc;
        if (!pdfDoc) return ;
        return this.getDocBuffer(isIncremental, isEnd).then(([isIncremental, docSize, bufferArray]) => {
            const ret = this.checkUploadFileSize(docSize, true);
            if (!ret) {
                this.autoSaveOnDocModifiedSwitch = 'off';
                return Promise.reject();
            }
            this.setAutoSaveStatus('loading');
            if (isIncremental) {
                return storageAppApi.appendContentStream(currentDocObject.docId, bufferArray).then(data => {
                    currentDocObject.lastDocId = data.docId;
                    return data;
                });
            }
            // 1
            return storageAppApi.setContentStream(currentDocObject.lastDocId||currentDocObject.docId, bufferArray, 'application/pdf').then(res => {
                this.setCurrentDoc(res);
                return res;
            });
        }).then(res => {
            const stateHandleManager = PDFVIEWER.getStateHandlerManager();
            const currentStateName = stateHandleManager.getCurrentStates().getStateName();
            this.updateStorageSpaceSize();
            this.setAutoSaveStatus('success');

            const activeElement = document.activeElement;
            const isEditing = activeElement.tagName === 'INPUT';
            if (['page-editor', 'touch-up-editor'].includes(currentStateName) && isEditing) {
            // if (['page-editor', 'touch-up-editor'].includes(currentStateName)) {
                return res;
            }
            // 如果有签名未应用，则不设置modified=false
            const onlineSignList = PDFVIEWER.getOnlineSignList();
            if (onlineSignList && onlineSignList.length) return res;
            this.setModified(false);
            return res;
        }).finally(() => {
            this.setAutoSaveStatus('hide');
        });
    }
    // status:null\loading\success\hide
    @action setAutoSaveStatus (status) {
        if (this.autoSaveStatus === 'success' && status && status !== 'loading') {
            status = 'success';
            const date = new Date();
            let hour = date.getHours();
            if (hour < 10) hour = '0' + hour;
            let minute = date.getMinutes();
            if (minute < 10) minute = '0' + minute;
            let second = date.getSeconds();
            if (second < 10) second = '0' + second;
            this.setCurAutoSavedAtTime(hour + ':' + minute + ':' + second);
        }
        this.autoSaveStatus = status;
    }
    @action getRootFolder () {
        if (this.rootFolder) return Promise.resolve(this.rootFolder);
        return storageAppApi.getUserPath().then(res => {
            return storageAppApi.getObjectByPath(res.data).then(data => {
                data.name = intl.get('FoxitStorage.Documents.Title');
                this.rootFolder = data;
                return data;
            });
        });
    }
    @action onSubscribe () {
        window.pdfui.eventEmitter.emit('need-pay-event');
    }
    // 创建共享文档
    checkShareFileSize (docSize) {
        const checkSize = size => {
            if (size > 1024 * 1024 * COLLABORATION_FILE_SIZE_LIMIT) {
                message.error(intl.get('collaboration.Dlg.FileExceededSize', { fileSize: 30 }));
                return Promise.reject('FileExceededSize');
            }
            return Promise.resolve();
        }
        if (docSize === undefined) {
            const PDFUI = window.pdfui;
            const PDFVIEWER = PDFUI.pdfViewer;
            const pdfDoc = PDFVIEWER.currentPDFDoc;
            if (!pdfDoc) return Promise.resolve();
            return pdfDoc.getInfo().then(data => {
                const fileSize = data.doc.info.fileSize;
                return checkSize(fileSize);
            });
        }
        return checkSize(docSize);
    }
    @action createShareFile (docId, deadline, prohibitComment, userEmail, message) {
        const createShare = (docId, deadline, prohibitComment, userEmail, message, password) => {
            return storageAppApi.createShare(docId, deadline, prohibitComment, userEmail, message, password)
            .then(res => {
                store.collaborationStore.setReviewSessionID(res.reviewSessionID)
                
                return res
            }, (err) => {
                if (err.ret === 900006) {
                    // 密码错误
                    return this.promptPassword(password).then(newPwd => createShare(docId, deadline, prohibitComment, userEmail, message, newPwd));
                } else {
                    if (err.ret === 200020) {
                        err = intl.get("collaboration.Dlg.noPermission");
                    }
                    store.appStore.setGlobalMessage({ type: 'error', content: (typeof err === 'string') ? err : err.msg });
                }
            });
        }
        // 切换hand操作，防止edit相关操作未结束，取不到最新的文档数据
        const PDFUI = window.pdfui;
        const PDFVIEWER = PDFUI.pdfViewer;
        const stateHandleManager = PDFVIEWER.getStateHandlerManager();
        stateHandleManager && stateHandleManager.switchTo('hand');
        return this.checkShareFileSize().then(() => {
            if (docId) { 
                return createShare(docId, deadline, prohibitComment, userEmail, message);
            } else {
                // docId未指定，表示当前文档未上传CMIS，则上传当前文档
                return new Promise((resolve, reject) => {
                    
                    this.uploadCurrentDoc(undefined, undefined, objectInfo => {
                        createShare(objectInfo.docId, deadline, prohibitComment, userEmail, message).then(res => {
                            resolve(res);
                        }).catch(e => reject(e));
                    }).catch(e => {
                        this.autoSaveOnDocModifiedSwitch = 'off';
                        reject(e);
                    });
                });
            }
        });
    }
    // 显示输入密码弹窗
    @action promptPassword (password) {
        let notifyType, notifyContent;
        if (password) {
            notifyType = 'error';
            notifyContent = 'retry.invalidPassword';
        }
        return window.pdfui.promptPassword('', 'retry.inputPassword', 'retry.Password', 'body', notifyType, notifyContent);
        // .then(newPwd => {
        //     this.setPassword(newPwd);
        //     return newPwd;
        // });
    }
    /**
     * name规则校验，不能包含 '/', '\\', ':', '\"', '*'. '?', '<','>', '|'
     * @returns true: 表示包含特殊字符
     */
    @action regExpName (name) {
        name = name.trim();
        const pattern = new RegExp("[`*|{}:\\/<>/?|]");
        let ret = pattern.test(name);
        if (!ret) {
            ret = name.length === 0 || name.indexOf('\\') > -1;
        }
        if (ret) {
            message.error(intl.get('FoxitStorage.Error.NameIncludeSpecialCharacters'));
        }
        return ret;
    }
    @action getPrevFileName (name) {
        if (!name) return name;
        let lastPointIndex = name.lastIndexOf('.');
        if (lastPointIndex === -1) {
            lastPointIndex = name.length;
        }
        return name.substr(0, lastPointIndex);
    }
    @action getSuffix (name) {
        if (!name) return name;
        let lastPointIndex = name.lastIndexOf('.');
        if (lastPointIndex === -1) {
            lastPointIndex = name.length;
        }
        return name.substr(lastPointIndex);
    }
    // 检查上传的文件大小是否超出，不能超出可用容量、单文件不能超出1G
    @action checkUploadFileSize (fileSize, autoUpdate) {
        if (fileSize > 1 * 1024 * 1024 * 1024) {
            // 上传文档大小不能超过1G
            this.uploadFileSizeOverConfirm('fileSizeOut1GB', autoUpdate);
            return false;
        }
        if ((this.usedSize + fileSize) >= this.maxSize) {
            this.uploadFileSizeOverConfirm(null, autoUpdate);
            return false;
        }
        return true;
    }
    @action saveCurrentDocToFoxitStorage (folder, newDocName) {
        if (this.regExpName(newDocName)) return Promise.reject();
        const PDFUI = window.pdfui;
        const PDFVIEWER = PDFUI.pdfViewer;
        const pdfDoc = PDFVIEWER.currentPDFDoc;
        const folderId = folder.docId;
        const onSuccess = (objectInfo) => {
            this.setCurrentDoc(objectInfo);
            store.docStore.docInfo.fileName = objectInfo.docName;
            this.setModified(false);
            this.updateStorageSpaceSize();
        }
        // 切换hand操作，防止edit相关操作未结束，取不到最新的文档数据
        const stateHandleManager = PDFVIEWER.getStateHandlerManager();
        stateHandleManager && stateHandleManager.switchTo('hand');
        // 判断是否重名
        return this.queryFileInFolder(newDocName, folderId).then(res => {
            return new Promise((resolve, reject) => {
                const saveCurrentDoc = () => {
                    return pdfDoc.getDocBuffer(PDFVIEWER, true).then(bufferArray => {
                        this.upload(folderId, bufferArray, newDocName, 'application/pdf', objectInfo => {
                            onSuccess(objectInfo);
                            resolve(objectInfo);
                        });
                    })
                }
                if (res) {
                    // 已存在相同文件名的文件
                    const duplicateFileNameTitle = intl.formatMessage({ id: 'Private.duplicateFileNameTitle' });
                    const duplicateFileNameContent = intl.formatMessage({ id: 'Private.duplicateFileNameContent' }, { FileName: newDocName });
                    PDFUI.confirm({
                        title: duplicateFileNameTitle,
                        message: duplicateFileNameContent,
                        okText: intl.formatMessage({ id: 'Save' })
                    }).then(() => {
                        // replace
                        return storageAppApi.deleteObject(res.docId).then(() => {
                            saveCurrentDoc();
                        });
                    }).catch(reject);
                }
                // else if (this.currentDocObject) {
                //     return storageAppApi.deleteObject(this.currentDocObject.docId).then(() => {
                //         saveCurrentDoc();
                //     });
                // }
                else {
                    saveCurrentDoc();
                }
            });
        });
    }
    // 获取空白文件名称
    @action getBlankFileName () {
        // untitled_2023-01-11_15.32.33.pdf
        const formate = 'yyyy-MM-dd_hh.mm.ss';
        let name = intl.get('HeaderContainer.untitled');
        const d = new Date();
        return name + '_' + formate
            .replace('yyyy', d.getFullYear())
            .replace('MM', (() => {
                let month = d.getMonth() + 1;
                if (month < 10) month = '0' + month;
                return month;
            })())
            .replace('dd', (() => {
                let date = d.getDate();
                if (date < 10) date = '0' + date;
                return date;
            })())
            .replace('hh', (() => {
                let hours = d.getHours();
                if (hours < 10) hours = '0' + hours;
                return hours;
            })())
            .replace('mm', (() => {
                let minutes = d.getMinutes();
                if (minutes < 10) minutes = '0' + minutes;
                return minutes;
            })())
            .replace('ss', (() => {
                let seconds = d.getSeconds();
                if (seconds < 10) seconds = '0' + seconds;
                return seconds;
            })()) + '.pdf';
    }
    // 添加、删除或者更新 UploadFile status: 'success|error|uploading'
    @action setUploadFile (id, name, file, folderId, status) {
        const uploadFiles = this.uploadFiles || [];
        let index = -1;
        for (let _index = 0; _index < uploadFiles.length; _index++) {
            if (id === uploadFiles[_index].id) {
                index = _index;
                break;
            }
        }
        if (['success'].includes(status) && index > -1) {
            this.uploadFiles.splice(index, 1);
            return ;
        }
        if (index === -1) {
            this.uploadFiles.push({ id, name, file, folderId, status });
        } else {
            const item = uploadFiles[index];
            if (!folderId) folderId = item.folderId;
            if (!file) file = item.file;
            this.uploadFiles.splice(index, 1, { id, name, file, folderId, status });
        }
    }
    // 从本地上传文件
    @action uploadFileFromeLocal (folder, onSuccess) {
        return new Promise((resolve, reject) => {
            let last = folder;
            let fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.multiple = true;
            fileInput.accept = '.txt,.text,.xls,.xlt,.xlsx,.xltx,.xlsm,.xlsb,.xltm,.csv,.hwp,.wps,.pdf,.htm,.html,.shtml,.bmp,.DIB,.jpg,.jpeg,.jpe,.gif,.tif,.tiff,.png,.vsd,.vsdx,.ppt,.pptx,.pot,.potx,.pptm,.ppsx,.ppsm,.potm,.doc,.rtf,.docx,.dot,.dotx,.docm,.dotm,.wpd';
            fileInput.onchange= e => {
                const files = e.target.files;
                if (!files || files.length === 0) reject('No file selected');
                // 验证剩余空间是否充足
                const uploadFiles = this.uploadFiles;
                let allFileSize = 0;
                for (let index = 0; index < files.length; index++) {
                    allFileSize += files[index].size;
                }
                for (let index = 0; index < uploadFiles.length; index++) {
                    const item = uploadFiles[index];
                    const file = item.file;
                    if (item.status === 'error' || !file) continue;
                    allFileSize += file.size;
                }
                if ((this.usedSize + allFileSize) >= this.maxSize) {
                    this.uploadFileSizeOverConfirm();
                    reject('fileSizeOut');
                    return ;
                }
                let promise = Promise.resolve(last);
                if (!last) {
                    console.log("getRootFolder 2")
                    promise = this.getRootFolder().then(rootFolder => {
                        return rootFolder;
                    }, reject);
                }
                return promise.then(last => {
                    // 上传所有选中的文档
                    const promises = [];
                    for (let index = 0; index < files.length; index++) {
                        const file = files[index];
                        const fileName = file.name;
                        const fileType = file.type;
                        const id = Date.now() + '' + index;
                        this.setUploadFile(id, fileName, file, last.docId, 'uploading');
                        promises.push(
                            file.arrayBuffer().then(buffer => {
                                return buffer;
                            }).then(buffer => {
                                return this.upload(last.docId, buffer, fileName, fileType, () => {
                                    this.setUploadFile(id, fileName, file, last.docId, 'success');
                                    onSuccess && onSuccess();
                                }, id).then(()=>{
                                }, ()=>{
                                    this.setUploadFile(id, fileName, file, last.docId, 'error');
                                });
                            })
                        );
                    }
                    return Promise.all(promises).then(() => {
                        resolve();
                    }, () => {
                        reject();
                    }).finally(() => {
                        fileInput = null;
                    }).catch(e => {
                        reject(e)
                    });
                });
            }
            fileInput.click();
        });
    }
    // storage上的文件另存为其他格式
    @action async storageDocumentSaveAs (docId, folder, newDocName, config) {
        if (this.regExpName(newDocName)) return Promise.reject();
        const prevFileName = this.getPrevFileName(newDocName);
        const suffix = this.getSuffix(newDocName).toLocaleLowerCase();
        const folderId = folder.docId;
        if (['.htm', '.html'].includes(suffix)) {
            newDocName = prevFileName + '.zip';
        }
        
        // 切换hand操作，防止edit相关操作未结束，取不到最新的文档数据
        const PDFUI = window.pdfui;
        const PDFVIEWER = PDFUI.pdfViewer;
        const stateHandleManager = PDFVIEWER.getStateHandlerManager();
        stateHandleManager && stateHandleManager.switchTo('hand');

        const setReject = (err) => {
            err && message.error(err);
            return Promise.reject(err);
        }

        let queryResult = await this.queryFileInFolder(newDocName, folderId);
        if (queryResult) {
            return setReject(intl.get('FoxitStorage.Error.DuplicateName'));
        }
        let type;
        switch (suffix) {
            case '.doc': type = 26; break;
            case '.docx': type = 11; break;
            case '.rtf': type = 25; break;
            case '.pptx': type = 22; break;
            case '.xml': type = 32; break;
            case '.xlsx': type = 14; break;
            case '.htm':
            case '.html': type = 30; break;
            case '.png':
            case '.jpg':
            case '.jpeg':
            case '.bmp': type = 6; break;
        }
        if (type === undefined) {
            return setReject('File format not supported.');
        }
        const docName = prevFileName + '.pdf'
        queryResult = await this.queryFileInFolder(docName, folderId);
        if (queryResult) {
            return setReject(intl.get('FoxitStorage.Error.DuplicateName'));
        }
        const objectInfo = await new Promise((resolve, reject) => {
            this.uploadCurrentDoc(folderId, docName, objectInfo => {
                resolve(objectInfo);
            }).catch((e) => {
                reject(e);
            });
        });
        docId = objectInfo.versionSeriesId;

        const convertResult = await storageAppApi.doConvert([{ 
            docid: 'cmisId-' + docId, 
            password: '',
        }], type, {}, Object.assign(config || {}, {
            saveToCmisFolderId: folderId,
            saveToCmisFileName: newDocName,
        })).finally(() => {
            store.taskStore.setHasTask(false);
            storageAppApi.deleteObject(objectInfo.docId);
        }).catch(e => {
            return setReject(e.msg);
        });
        this.updateStorageSpaceSize();
        return convertResult;
    }
    // Storage总大小
    @computed get maxSize () {
        if (this.isPremiumUser) {
            if (store.userStore.isEdu && !store.userStore.isSuperAdmin) {
                return 5 * 1024 * 1024 * 1024; // 教育 高级用户 5GB容量
            }
            return 20 * 1024 * 1024 * 1024; // 高级用户20GB容量
        }
        return 1 * 1024 * 1024 * 1024; // 普通用户1GB容量
        // return 5 * 1024 * 1024; // 测试
    }
    // 判断是否高级用户
    @computed get isPremiumUser () {
        // {
        //     isTrial:_____APP_STATE_____.accountStore.isTrial, // 试用期
        //     isTrialExpired:_____APP_STATE_____.accountStore.isTrialExpired, // 已试用到期
        //     isActive:_____APP_STATE_____.accountStore.isActive, // 已激活
        //     isExpired:_____APP_STATE_____.accountStore.isExpired, // 已过期
        //     isNoFirstTrail:_____APP_STATE_____.accountStore.isNoFirstTrail, // 是否未试用过
        //     isEnterpriseUser:_____APP_STATE_____.userStore.isEnterpriseUser, // 企业用户
        //     isEdu:_____APP_STATE_____.userStore.isEdu, // 教育用户
        //     hasEditPermissionAndEnterpriseUser:_____APP_STATE_____.userStore.hasEditPermissionAndEnterpriseUser, // 企业用户是否已配置
        // }

        if (store.accountStore.isTrial && !store.accountStore.isTrialExpired) return true; // 试用期，且未到期
        if (store.userStore.isEnterpriseUser && store.userStore.hasEditPermissionAndEnterpriseUser) return true; // 企业用户且已配置权限
        // if (store.userStore.isEdu) return true; // 教育用户
        if (store.accountStore.isActive) return true; // 已激活用户
        return false;
    }
    @computed get showUpgrade () {
        const { isEnterpriseUser, hasEditPermissionAndEnterpriseUser, isEdu } = store.userStore;
        let _showUpgrade = !this.isPremiumUser;
        if (isEdu || (isEnterpriseUser && !hasEditPermissionAndEnterpriseUser)) {
            _showUpgrade = false;
        }
        return _showUpgrade;
    }
    // 是否禁用storage
    @computed get isDisableStorage () {
        const { cloudOnlineStorage } = store.appStore;
        const ret = ((0x00000040 & cloudOnlineStorage) != 0 && cloudOnlineStorage != -1); // true: 有Storage权限, false: 没有Storage权限，
        if (store.userStore.hasSignIn && !store.userStore.isEnterpriseUser) return false;
        return !ret;
    }
    @computed get isOutOfStorage () {
        return this.usedSize >= this.maxSize;
    }
    // 是否开启自动保存到CMIS
    isAutoSave () {
        const localSettings = window.localStorage.getItem('PREFERENCES-DOCUMENTS');
        if (!localSettings) return false;
        const isCollaborationMode = store.appStore.isCollaborationMode();
        const inTeamsApp = store.teamsAppStore.inTeamsApp;
        if (isCollaborationMode || inTeamsApp) return false;
        if (store.appStore.isFromServiceModeOfClient) return false; // exe 打开方式
        const { autoUploadToFoxitStorage } = JSON.parse(localSettings);
        return !!autoUploadToFoxitStorage;
    }
    // 文档更新操作后，5秒内无更新操作，则自动保存
    autoSaveOnDocModified (isIncremental, isEnd) {
        this.timer && clearTimeout(this.timer);
        this.autoSaveOnDocModifiedParams = [isIncremental, isEnd];
        this.timer = setTimeout(() => {
            this.timer = undefined;
            this.autoSaveOnDocModifiedParams = undefined;
            this.updateCurrentDocToCmis(isIncremental, isEnd); // 增量方式保存
        }, 5000);
    }
    // 文档更新操作后，立即执行自动保存
    @action syncAutoSaveOnDocModified (isIncremental, isEnd) {
        store.appStore.showLoading(true);
        const pdfViewer = store.viewer.pdfViewer;
        const stateHandleManager = pdfViewer.getStateHandlerManager();
        stateHandleManager && stateHandleManager.switchTo('hand');
        if (isIncremental === undefined && isEnd === undefined && this.autoSaveOnDocModifiedParams) {
            [isIncremental, isEnd] = this.autoSaveOnDocModifiedParams;
        }
        return new Promise((res, rej) => {
            setTimeout(() => { // 防止立即执行自动保存后，还有其他操作触发docModify
                if (store.appStore.docModified) {
                    clearTimeout(this.timer);
                    this.autoSaveOnDocModifiedParams = undefined;
                    this.updateCurrentDocToCmis(isIncremental, isEnd).then(_ => {
                        res(_);
                    }).catch(e => {
                        rej(e);
                    });
                } else {
                    res();
                }
            }, 1000);
        }).finally(() => {
            store.appStore.showLoading(false);
        });
    }
    // 剩余空间不足 提醒确认框
    async showInsufficientFreeSpaceConfirm () {
        if (this.showInsufficientFreeSpaceConfirmCount > 0) return ;
        if (!this.showUpgrade && store.userStore.isEnterpriseUser){
            if(store.userStore.isEnterpriseUser){
                return window.pdfui.alert({
                    message: intl.get('FoxitStorage.Error.EnterpriseUserOutOfStorage'),
                    level: 'warning',
                });
            }
            return;
        }

        const isPremiumUser = this.isPremiumUser;
        if (isPremiumUser) return ;
        // // 如果当前用户已被企业授权则不提示
        // const hasAssignCloudLicenseState = await storageAppApi.hasAssignCloudLicenseState();
        const isNoFirstTrail = store.accountStore.isNoFirstTrail; // 是否未试用过
        if (isNoFirstTrail) return ;
        if (!window.pdfui) {
            this.showInsufficientFreeSpaceConfirmTimer && clearTimeout(this.showInsufficientFreeSpaceConfirmTimer);
            return this.showInsufficientFreeSpaceConfirmTimer = setTimeout(() => {
                this.showInsufficientFreeSpaceConfirm();
            }, 1500);
        }
        store.userStore.doSendGAEvent({ action: 'Warning_downgrade_from_premium', label: 'Event', category: 'Foxit_Storage' });
        this.showInsufficientFreeSpaceConfirmCount += 1;
        if (!this.showUpgrade) {
            return window.pdfui.alert({
                id: 'FoxitStorageErrorOverMaxSizeStored',
                again: true,
                message: intl.get('FoxitStorage.Error.OverMaxSizeStored', { maxSize: bytesTobytes(this.maxSize) }),
                level: 'prompt',
                okText: intl.get('FoxitStorage.Get')
            });
        }
        return window.pdfui.confirm({
            id: 'FoxitStorageErrorOverMaxSizeStored',
            again: true,
            message: intl.get('FoxitStorage.Error.OverMaxSizeStored', { maxSize: bytesTobytes(this.maxSize) }),
            level: 'prompt',
            okText: intl.get('FoxitStorage.Upgrade'),
            cancelText: intl.get('FoxitStorage.Get')
        }).then(() => {
            this.onSubscribe();
        }, () => {});
    }  
    // 上传文件大小超出限制 提醒确认框
    uploadFileSizeOverConfirm (type, automatically) {
        const isPremiumUser = this.isPremiumUser;
        if (isPremiumUser) {
            if (type === 'fileSizeOut1GB') {
                message.error(intl.get('FoxitStorage.Error.UploadFileOutSize'));
                return ;
            }
            store.userStore.doSendGAEvent({ action: 'Warning_premium_runs_out_of_storage_space', label: 'Event', category: 'Foxit_Storage' });
            return window.pdfui.confirm({
                message: intl.get(`FoxitStorage.Error.${automatically ? 'FailedAutoSaveOutOfStorage': 'OutOfStorage'}`),
                level: 'prompt',
                okText: intl.get('FoxitStorage.Ok'),
                cancelText: intl.get('FoxitStorage.Cancel')
            }).then(() => {}, () => {});
        }
        store.userStore.doSendGAEvent({ action: 'Warning_freemium_runs_out_of_storage_space', label: 'Event', category: 'Foxit_Storage' });
        const { isEdu } = store.userStore;
        return window.pdfui.confirm({
            message: intl.get(`FoxitStorage.Error.${automatically ? 'FailedAutoSaveOutOfStorageUpgrade': isEdu ? 'OutOfStorageUpgradeWithoutUpgrad' : 'OutOfStorageUpgrade'}`),
            level: 'prompt',
            okText: isEdu ? intl.get('FoxitStorage.Get') : intl.get('FoxitStorage.Upgrade'),
            cancelText: intl.get('FoxitStorage.Cancel')
        }).then(() => {
            if (isEdu) return ;
            this.onSubscribe();
        }, () => {});
    }
    // 查询目录下文件
    queryFileInFolder (fileName, folderId) {
        console.log("getRootFolder 3")
        let promise;
        if (folderId === undefined) {
            promise = this.getRootFolder().then(root => root.objectId);
        } else {
            promise = Promise.resolve(folderId);
        }
        return promise.then(objectId => {
            return storageAppApi.queryObjectByName({
                name: fileName, 
                folderId: objectId
            });
        });
    }
    // 获取当前文档
    getCurrentDoc () {
        const PDFUI = window.pdfui;
        const PDFVIEWER = PDFUI.pdfViewer;
        return PDFVIEWER.currentPDFDoc;
    }
    // 自定义退出文档到首页的方法
    customSetOnShowToSaveBeforeOpen (oldOnShowToSaveBeforeOpen) {
        store.appStore.setShowToSaveBeforeOpen((callback) => {
            let ret = this.currentDocObject && store.appStore.docModified && this.autoSaveOnDocModifiedSwitch === 'on';
            if (store.docStore.docDriveName && store.docStore.docDriveName !== this.storageDriveName) {
                ret = false;
            }
            if (ret) {
                this.beforeCloseDocument().then(() => {
                    store.appStore.emitEvent(APP_CONSTANTS.SDK_WILL_CLOSE_DOC);
                    callback();
                });
            } else {
                let timer = setInterval(() => {
                    if (this.autoSaveStatus !== 'loading') {
                        timer && clearInterval(timer);
                        oldOnShowToSaveBeforeOpen(callback);
                    }
                }, 0);
            }
        });
    }
    // 关闭文档之前，如果文档有更新过，则立即触发自动保存
    @action beforeCloseDocument () {
        return new Promise((resolve, reject) => {
            if (!this.currentDocObject || !store.appStore.docModified) return resolve;
            const pdfViewer = store.viewer.pdfViewer;
            const onlineSignList = pdfViewer.getOnlineSignList();
            const stateHandleManager = pdfViewer.getStateHandlerManager();
            const switchHandUpdateCurrentDoc = () => {
                stateHandleManager.switchTo('hand');
                setTimeout(() => {
                    this.timer && clearTimeout(this.timer);
                    this.updateCurrentDocToCmis(false, true).then(() => {
                        setTimeout(() => {
                            resolve();
                        }, 500);
                    }, () => {
                        this.setModified(false);
                        resolve();
                    }).catch(e => {
                        reject(e);
                    });
                }, 500);
            }

            // 有签名未应用
            if (onlineSignList && onlineSignList.length) { 
                return this.applySign((ret) => {
                    if (ret === 'success' && onlineSignList.every(item => item.signType === 'foxit-eSign')) {
                        this.setModified(false);
                        resolve();
                    } else {
                        switchHandUpdateCurrentDoc();
                    }
                });
            }
            switchHandUpdateCurrentDoc();
        });
    }
    applySign (callback) {
        const pdfViewer = store.viewer.pdfViewer;
        const onlineSignList = pdfViewer.getOnlineSignList();
        if (!onlineSignList || onlineSignList.length === 0) return ; 
        const cancel = 'SignatureListContainer.optionsDialog.discard';
        store.appStore.onShowWarningMessage((isCurOk, date) => {
            if (isCurOk) {
                if (onlineSignList.every(item => item.signType === 'foxit-eSign')) {
                    store.viewer.pdfui.eventEmitter.emit('need-sign-tip', () => {
                        this.onAutoUploadFileSuccessOnOpenDoc = () => {
                            setTimeout(() => {
                                callback && callback('success');
                            }, 100);
                        };
                    });
                } else {
                    pdfViewer.getCurrentPDFDoc().addFillSignSignaturesToDoc(pdfViewer, null, () => {
                        callback && callback('success');
                    });
                    window.sessionStorage.setItem('applyEventFromCloseSave', 'yes');
                }
            } else if (date.key === cancel) {
                const $ = window.UIExtension.jQuery;
                onlineSignList.forEach(({id})=>$(`#${id}`).remove());
                pdfViewer.getOnlineSignManger().clear();
                store.viewer.pdfui.eventEmitter.emit('no-sign-apply');
                $('.fv__pdf-page-handler-container .mouse-move-img').remove();
                callback && callback('cancel');
            }
        }, {
            message: 'SignatureListContainer.optionsDialog.needApplyFillSign',
            cancel: cancel,
            ok: 'SignatureListContainer.optionsDialog.applyAll',
            closeable: false,
            customClose: false,
            iconType: 'alert'
        });
    }
    // 是否已经导航过了
    hasNavigation () {
        const key = 'navigation-key';
        if (localStorage.getItem(key)) return true;
        return false;
    }

    /**
     * 获取Doc buffer 
     * @param {*} isIncremental 是否增量方式
     * @param {*} isEnd 是否结束所有操作
     * @returns [isIncremental, docSize, bufferArray]
     */
    getDocBuffer (isIncremental, isEnd) {
        const PDFUI = window.pdfui;
        const PDFVIEWER = PDFUI.pdfViewer;
        const pdfDoc = PDFVIEWER.currentPDFDoc;
        if (!pdfDoc) return ;
        const buffers = [];
        let getDocbuffer;
        if (isIncremental) {
            const incremental = 0x0001;
            // 获取增量buffer. 注意：底层可能返回的是全量buffer，需要使用getLastSaveFlags进一步判断
            getDocbuffer = pdfDoc.getStream(({ arrayBuffer }) => {
                buffers.push(arrayBuffer);
            },  incremental | 0x0002, isEnd)
            .then(() => {
                return pdfDoc.getLastSaveFlags().then(lastSaveFlag => {
                    isIncremental = (lastSaveFlag & incremental) !== 0;
                    // console.log('==========', {isIncremental, lastSaveFlag});
                });
            })
            .then(() => {
                return buffers;
            });
        } else {
            getDocbuffer = pdfDoc.getDocBuffer(PDFVIEWER, isEnd);
        }
        return getDocbuffer.then(bufferArray => {
            let docSize = 0;
            bufferArray.forEach(buffer => {
                docSize += buffer.byteLength;
            });
            return [isIncremental, docSize, bufferArray];
        });
    }

    setModified (data) {
        const PDFUI = window.pdfui;
        const PDFVIEWER = PDFUI.pdfViewer;
        const pdfDoc = PDFVIEWER.currentPDFDoc;
        if (!pdfDoc) return ;
        store.appStore.updatePreventDocModifiedFlag(data);
        pdfDoc.docModified = data;
        store.appStore.docModified = data;
    }

    // 转换文档为PDF
    doConvertToPDF (docId, docName) {
        if (!docId) return Promise.reject('docId undefined');
        const type = convertController.getTaskTypeByFileName(docName);
        if (type === CONVERT_TYPE.UNKNOWN) {
            store.taskStore.setTaskMessage({ info: "NotSupportedFormat", type: 'error', failed: true }, 5000);
            return Promise.reject('NotSupportedFormat');
        }
        const lastIndex = docId.lastIndexOf(',');
        docId = docId.substr(0, lastIndex === -1 ? docId.length : lastIndex);
        store.taskStore.onUpdateTaskMessage({ fileName: docName, status: 'task-step-begin-upload', ret: 0 }, type);
        return storageAppApi.doConvert([{ 
            docid: 'cmisId-' + docId, 
            password: '',
        }], type).then(res => {
            return new Promise(resolve => {
                store.taskStore.onUpdateTaskMessage({ status: 'task-step-doing-by-gsdk', progress: 100 }, type);
                let url = res && res.url;
                let docNameLastIndex = docName.lastIndexOf('.');
                let prevDocName = docName.substr(0, docNameLastIndex === -1 ? docName.length : docNameLastIndex);
                if (url) url = url.replace('filename=stream', `filename=` + prevDocName);
                setTimeout(() => {
                    resolve([url, prevDocName + '.pdf']);
                }, 500);
            });
        }, () => {
            store.taskStore.setTaskMessage({ title: 'Notification.ConvertFailed', info: 'Notification.FailedInfo', type: 'error'}, 6000, true);
        }).finally(() => {
            store.taskStore.setHasTask(false);
        });
    }
}

export default StorageAppStore;
